import { createSlice } from "@reduxjs/toolkit";

import { endBreakoutSession, startBreakoutSession } from "shared/reducers/classroom";
import { WorkbookSliceStateType } from "shared/types/workbook";

const initialState: WorkbookSliceStateType = {
  questions: {},
  workbooks: {},
};

const workbookSlice = createSlice({
  name: "workbook",
  initialState,
  reducers: {
    setQuestion(state, action) {
      const { uuid, type, components, multipleChoiceData, question, flavor } = action.payload;
      state.questions[uuid] = {
        uuid,
        type,
        components,
        multiple_choice_data: multipleChoiceData,
        question,
        flavor,
      };
    },

    setWorkbook(state, action) {
      const { uuid, breakoutRoomId, answers, flavor } = action.payload;
      state.workbooks[uuid] = { uuid, breakout_room_id: breakoutRoomId, answers, flavor };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(startBreakoutSession, (state) => initialState);
    builder.addCase(endBreakoutSession, (state) => initialState);
  },
});

export const { setQuestion, setWorkbook } = workbookSlice.actions;

const workbookSliceReducer = workbookSlice.reducer;
export { workbookSliceReducer };
